var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlowingStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.35,
    height: 10.35,
    viewBox: "0 0 10.35 10.35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "star",
    clipPath: "url(#clip0_3491_84249)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "star",
    d: "M3.26154 2.4967L4.36044 0.483516C4.71209 -0.158242 5.64396 -0.158242 5.9956 0.483516L7.0945 2.4967C7.27033 2.82198 7.53406 3.08571 7.85934 3.26154L9.87253 4.36044C10.5143 4.71209 10.5143 5.64396 9.87253 5.9956L7.85934 7.0945C7.53406 7.27033 7.27033 7.53406 7.0945 7.85934L5.9956 9.87253C5.64396 10.5143 4.71209 10.5143 4.36044 9.87253L3.26154 7.85934C3.08571 7.53406 2.82198 7.27033 2.4967 7.0945L0.483516 5.9956C-0.158242 5.64396 -0.158242 4.71209 0.483516 4.36044L2.4967 3.26154C2.82198 3.08571 3.08571 2.82198 3.26154 2.4967Z",
    fill: "#105EFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3491_84249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.35,
    height: 10.35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingStar);
export default __webpack_public_path__ + "static/media/glowing_star.9352c25a5b5f09bdd297656a03f01255.svg";
export { ForwardRef as ReactComponent };